// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/arrow-right-left.js';

import { paths } from '../generated/arrow-right-left';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('arrow-right-left', Original, paths);
